export const DEFAULT_FONT_SIZE = '14px';

export const ROBOTO_FONT_FAMILY = "'Roboto', sans-serif";
